import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AllToolsSection from './components/AllToolsSection';
import WhyUsSection from './components/WhyUsSection';
import TestimonialSection from './components/TestimonialSection';

const HomePage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || window.location.origin;
    
    // 动态设置页面 title
    document.title = 'PDF Converter Tools - Free Online PDF to Word, Excel, PPT Converter';
    
    // 动态设置 meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Free online PDF converter tools - Convert PDF to Word, Excel, PPT, and images. Merge, split, and compress PDF files easily. Fast, secure, and no registration required.');
    
    // 动态设置 canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', siteUrl);

    // WebSite Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "PDF Converter Tools",
      "url": siteUrl,
      "description": "Free online PDF converter tools - Convert PDF to Word, Excel, PPT, and images. Merge, split, and compress PDF files easily.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    };

    // WebApplication Schema
    const webAppSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "PDF Converter Tools",
      "url": siteUrl,
      "applicationCategory": "UtilitiesApplication",
      "operatingSystem": "Any",
      "browserRequirements": "Requires JavaScript. Requires HTML5.",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "description": "Free online PDF converter and editor tools. Convert PDF to Word, Excel, PowerPoint, and images. Merge, split, and compress PDF files with ease.",
      "featureList": [
        "PDF to Word conversion",
        "PDF to Excel conversion",
        "PDF to PowerPoint conversion",
        "Image to PDF conversion",
        "PDF to Image conversion",
        "Merge PDF files",
        "Split PDF files",
        "Compress PDF files"
      ],
      "screenshot": "https://public.readdy.ai/ai/img_res/f70f423848adde888d3fe8de63fb3b19.jpg"
    };

    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "PDF Converter Tools",
      "url": siteUrl,
      "logo": `${siteUrl}/logo.png`,
      "description": "Free online PDF converter and editor tools provider",
      "sameAs": [
        "https://twitter.com/pdfconvertertools",
        "https://facebook.com/pdfconvertertools"
      ]
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(websiteSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(webAppSchema);
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script3);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <AllToolsSection />
      <WhyUsSection />
      <TestimonialSection />
      <Footer />
    </div>
  );
};

export default HomePage;